import React from 'react';
import { Typography } from '@material-ui/core';

import { Box } from 'components';

import styles from './styles';

const SignInImage = () => {
  const classes = styles();

  return (
    <Box className={classes.rightContent}>
      <Box className={classes.rightImg}>
        <Box className={classes.acceleratorText}>
          <Typography className={classes.acceText}>
            Invest in best-in-class startups backed by the world’s largest
            accelerator.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default SignInImage;
